import fetch from 'cross-fetch'
import {logOutAction} from '../actions/authActions'
import {store } from '../index'
import axios from 'axios'

export const apiBaseUrl = process.env.API_URL

export function get(url, token = null) {
    return axios({
        method: "GET",
        url: apiBaseUrl + url,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/x.laravel.v1+json',
            'Authorization': 'Bearer ' + token
        }
    }).then(function (response) {
        /* if (!response.ok) {
            throw Error(response.statusText);
        } */
        return response;
    }).catch(function(error){
        if(error.message === 'Unauthorized'){
            store.dispatch(logOutAction());
        }else{
            throw Error(error);
        }
        
    })
}

export function post(url, data, token = null, errorCallback = null, contentType=null) {
    let requestHeaders = {
        'Content-Type': contentType ? contentType : 'application/json',
        'Accept': 'application/x.laravel.v1+json',
        'Authorization': token ? 'Bearer ' + token : null
    }

    return axios({
        method: "POST",
        url: apiBaseUrl + url,
        data: !contentType || contentType === 'application/json' ? JSON.stringify(data) : data,
        headers: requestHeaders
    }).then(function (response) {
        /* if (!response.ok) {
            if (errorCallback)
                errorCallback(response)
            else
                throw Error(response.statusText);
        } */
        return response;
    }).catch(function(error){
        if(error.message === 'Unauthorized'){
            store.dispatch(logOutAction());
        }else{
            throw Error(error);
        }
    })

}



// WEBPACK FOOTER //
// ./src/services/apiServices.js